module.exports = __webpack_public_path__ + "static/media/SakenomyLogo_nocopy_C.ceddc0d3.jpg";